import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeDateBaseComponent } from './e5core-ui-work-field-type-date-base';
import { MatDatepickerInputEvent } from '@angular/material';

@Component({
  selector: 'e5core-ui-work-field-type-date-material',
  templateUrl: './e5core-ui-work-field-type-date-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-date-material.component.css']
})
export class E5coreUiWorkFieldTypeDateMaterialComponent extends E5coreUiWorkFieldTypeDateBaseComponent implements OnInit {

  ngOnInit() {
    super.ngOnInit() ;
  }

  onMatChange($event: MatDatepickerInputEvent<Date>) {
    this.valueChange.emit({$event: $event, value: $event.value}) ;
  }

}
